import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import type { AiModelOption } from '../hooks/useAiModels';

/**
 * Выбор модели (пакет 3 переезда AI на OpenRouter). Модели подписаны по результату и цене,
 * а не одним названием. Пустой список (каталог ещё не загрузился) — выбор не показывается,
 * запрос уходит с умолчанием.
 */
export default function ModelSelect({
  models, value, onChange, disabled, ariaLabel, testId, className,
}: {
  models: AiModelOption[];
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
  ariaLabel: string;
  testId?: string;
  className?: string;
}) {
  if (models.length === 0) return null;
  const current = models.some(m => m.id === value) ? value : (models.find(m => m.isDefault) ?? models[0]).id;
  return (
    <Select value={current} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={className ?? 'h-7 text-xs w-auto gap-1 px-2'} aria-label={ariaLabel} data-testid={testId}>
        {/* В кнопке — только название, подпись и цена видны в списке. */}
        <SelectValue>{models.find(m => m.id === current)?.label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {models.map(m => (
          <SelectItem key={m.id} value={m.id} textValue={m.label}>
            <span className="flex flex-col">
              <span>{m.label}</span>
              <span className="text-[10px] text-muted-foreground">{[m.note, m.price].filter(Boolean).join(' · ')}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
